import { httpGet } from '@/services/http';
import { transformMedia, BackendMedia, FrontendMedia } from '@/services/transform';

/** GET /api/public/media - 获取公开媒体报道列表 */
export async function getPublicMedia(): Promise<FrontendMedia[]> {
  try {
    const data = await httpGet<BackendMedia[]>('/public/media');
    return data.map(transformMedia);
  } catch (error) {
    console.error('获取公开媒体报道列表失败:', error);
    return [];
  }
}

/** GET /api/public/media/:id - 获取媒体报道详情 */
export async function getPublicMediaById(id: string): Promise<FrontendMedia | null> {
  try {
    const data = await httpGet<BackendMedia>(`/public/media/${id}`);
    return transformMedia(data);
  } catch (error) {
    console.error('获取媒体报道详情失败:', error);
    return null;
  }
}
